import { render } from "./PlatformFillIn.vue?vue&type=template&id=b12a28ae&scoped=true"
import script from "./PlatformFillIn.vue?vue&type=script&lang=js"
export * from "./PlatformFillIn.vue?vue&type=script&lang=js"

import "./PlatformFillIn.vue?vue&type=style&index=0&id=b12a28ae&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b12a28ae"]])

export default __exports__